import React from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import swal from 'sweetalert';
import { Portal } from 'react-portal';
import { spmfcloudFunctionUrl } from '../../../actions/salesforces';
import { fetchQueryData } from '../../../utils/sf-request';

class ModalFindEdited extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: [],
            selectedObject: {},
            showModal: false,
            textSearch: '',
            loading: false,
        };
        this.search = this.search.bind(this);
    }

    componentWillMount() {
    }

    async search() {
        if (this.state.loading) return;
        let query = 'SELECT ';
        const { columns, fieldToSearch, siteToken, publicKey } = this.props;
        columns.map((column) => {
            if (column.accessor) {
                if (column.accessor.indexOf('__r') > -1) {
                    query += `${column.accessor}.Name, `;
                } else if (column.accessor.toLowerCase() !== 'id') {
                    query += `${column.accessor}, `;
                }
            }
        });
        query += ` Id FROM ${this.props.sfTableName} WHERE (`;
        fieldToSearch.map((searchField, index) => {
            query += ` ${searchField} LIKE '%${this.state.textSearch}%' `;
            query += index === fieldToSearch.length - 1 ? '' : ' OR ';
            return query;
        });
        query += `) AND ${this.props.additionalFilter}`;
        this.setState({ loading: true });
        try {
            const searchResult = await fetchQueryData(query, siteToken, publicKey);
            this.setState({
                loading: false, data: searchResult.records || [],
            });
        } catch (error) {
            swal({
                text: error.toString(),
                title: 'Error when searching object',
            });
            this.setState({ loading: false });
        }
    }

    render() {
        return [
            <div className="form-group">
                <div className="input-group">
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Search for..."
                        value={this.state.selectedObject[this.props.shownAttribute] === undefined ? this.props.selectedObject[this.props.shownAttribute] : this.state.selectedObject[this.props.shownAttribute] || this.props.label}
                        onClick={() => this.setState({ showModal: true })}
                        style={{ zIndex: '0' }}
                    />
                    <span className="input-group-btn">
                        <button className="btn btn-default btn-primary" type="button" onClick={() => this.setState({ showModal: true })}>
                            <i className="fa fa-search" />
                        </button>
                    </span>
                </div>
            </div>,
            <Portal>
                <div className="modal modal-backdrop" tabIndex="-2" role="dialog" style={{ display: this.state.showModal ? 'block' : 'none' }}>
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => this.setState({ showModal: false })}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                                <h4 className="modal-title">Search {this.props.title}</h4>
                            </div>
                            <div className="modal-body">
                                <p style={{ textAlign: 'center' }}>
                                    {this.state.loading ? <i className="fa fa-spinner fa-spin" /> : null}
                                </p>
                                <div className="form-group">
                                    <div className="input-group">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Search for..."
                                            value={this.state.searchValue}
                                            onChange={e => this.setState({ textSearch: e.target.value })}
                                        />
                                        <span className="input-group-btn">
                                            <button className="btn btn-default btn-primary" type="button" onClick={this.search}>
                                                <i className="fa fa-search" />
                                            </button>
                                        </span>
                                    </div>
                                </div>
                                <ReactTable
                                    columns={this.props.columns}
                                    data={this.state.data}
                                    defaultPageSize={5}
                                    getTdProps={(state, rowInfo) => ({
                                        onClick: () => {
                                            this.props.onSelected(rowInfo.original);
                                            this.setState({ showModal: false, selectedObject: rowInfo.original });
                                        },
                                    })}
                                />
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-default"
                                    data-dismiss="modal"
                                    onClick={() => this.setState({ showModal: false })}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </Portal>,
        ];
    }
}

ModalFindEdited.propTypes = {
    onSelected: PropTypes.func.isRequired,
    title: PropTypes.string,
    columns: PropTypes.array,
    selectedObject: PropTypes.object,
    shownAttribute: PropTypes.string,
    sfTableName: PropTypes.string,
    fieldToSearch: PropTypes.array,
    siteToken: PropTypes.string.isRequired,
    additionalFilter: PropTypes.string,
    label: PropTypes.string,
    publicKey: PropTypes.string.isRequired,
};

ModalFindEdited.defaultProps = {
    title: '',
    columns: [],
    shownAttribute: 'Id',
    sfTableName: '',
    fieldToSearch: ['Id'],
    additionalFilter: '',
    label: null,
    selectedObject: {},
};


export default ModalFindEdited;



//////////////////
// WEBPACK FOOTER
// ./src/components/Portal/common/ModalFindEdited.js
// module id = 996
// module chunks = 0